import { useQuery } from "@tanstack/react-query";
import { Button, Card, Descriptions, Flex, Tag } from "antd";
import { useNavigate, useParams } from "react-router";
import { historyLogService } from "../../services/history-log.service";
import { format } from "date-fns";

export default function HistoryLogForm(){

  const { id } = useParams()

  const navigate = useNavigate()


  const { data: historyLog  } = useQuery({
    queryKey: ['historyLog', id],
    queryFn: () => historyLogService.getById(id),
    enabled: !!id
  })

  console.log(historyLog)


  return (
    <>
      <Card
        title={ (id ? "Detail" : "Tambah") + " Data"}
        actions={[
          <Flex key={'1'} style={{ paddingRight: 24 }} justify="flex-end" > 
            <Button onClick={() => navigate('/history-log')} variant="outlined" color="primary" >
              Kembali
            </Button>
          </Flex>
        ]}
      >
        <Descriptions
          bordered
          size="small"
          column={1}
          labelStyle={{ width: 210 }}
          items={[
            {
              label: 'Modul',
              children: historyLog?.data?.module
            },
            {
              label: 'Aksi',
              children: (
                (() => {
                  switch (historyLog?.data?.action) {
                    case 'CREATE':
                      return <Tag color="success" >{historyLog?.data?.action}</Tag>
                    case 'UPDATE':
                      return <Tag color="blue" >{historyLog?.data?.action}</Tag>
                    case 'DELETE':
                      return <Tag color="red" >{historyLog?.data?.action}</Tag>
                  }
                })()
              )
            },
            {
              label: 'Data Awal', 
              children: (
                <pre>
                  {JSON.stringify(historyLog?.data?.oldData, null, 2)}
                </pre>
              )
            },
            {
              label: 'Data Perubahan', 
              children: (
                <pre>
                  {JSON.stringify(historyLog?.data?.newData, null, 2)}
                </pre>
              )
            },
            {
              label: 'Updated By',
              children: `${historyLog?.data?.user.name} - ${historyLog?.data?.createdAt && format(new Date(historyLog?.data?.createdAt), 'EEEE, dd/MM/yyyy HH:mm')}`
            }
          ]}
        />
      </Card>
    </>
  )
}